import pro1 from "../assets/project1.JPG"
import pro2 from "../assets/project2.JPG"
import pro3 from "../assets/project4.JPG"
import pro4 from "../assets/project3.JPG"
import pro5 from "../assets/tributepage.JPG"
import pro6 from "../assets/app_form.JPG"
import pro7 from "../assets/parallax.JPG"
import pro8 from "../assets/doc.PNG"
import pro9 from "../assets/devland.JPG"
import pro10 from "../assets/resta.JPG"
import pro11 from "../assets/project11.png"
import pro12 from "../assets/project12.png"
import pro13 from "../assets/project13.png"
import pro14 from "../assets/project14.jpeg"
import pro15 from "../assets/project15.jpeg"

const ProjectcardData = [
    {
        imgsrc: pro15,
        title: "Weather App",
        text: "Weather App using HTML, CSS, JS (Responsive)",
        view: "https://weather-a6d43.web.app/",
        source: "https://github.com/iambibhu/Live-Weather-Check"
    },
    {
        imgsrc: pro14,
        title: "Life Timer",
        text: "Life Timer using HTML, CSS, JS (Responsive)",
        view: "https://lifetimer-41ec6.web.app/",
        source: "https://github.com/iambibhu/life-timer"
    },
    {
        imgsrc: pro1,
        title: "Morden Responsive Website",
        text: "Modern static website using HTML, CSS (Responsive)",
        view: "https://iambibhu.github.io/Modern-Responsive-Website",
        source: "https://github.com/iambibhu/Modern-Responsive-Website"
    },
    {
        imgsrc: pro3,
        title: "Portfolio Website",
        text: "Portfolio website using React JS, HTML, CSS (Responsive)",
        view: "https://my-portfolio-f7647.web.app/",
        source: "https://github.com/iambibhu/My-Portfolio"
    },
    {
        imgsrc: pro13,
        title: "Blog Website",
        text: "Blog Website using HTML, CSS (Responsive)",
        view: "https://blog-website-74fc2.web.app",
        source: " https://github.com/iambibhu/Blog-Website"
    },
    {
        imgsrc: pro11,
        title: "Music Website",
        text: "Music Website using HTML, CSS (Responsive)",
        view: "https://music-website-63d83.web.app/",
        source: "https://github.com/iambibhu/Music-Website"
    },
    {
        imgsrc: pro12,
        title: "YouTube clone",
        text: "YouTube clone using HTML, CSS (Responsive)",
        view: "https://ytclon-26363.web.app",
        source: "https://github.com/iambibhu/YT-clone"
    },
    {
        imgsrc: pro10,
        title: "Restaurant Website",
        text: "Documentation Website using HTML, CSS (Responsive)",
        view: "https://restaurant-website-e0fb2.web.app/",
        source: "https://github.com/iambibhu/Restaurant-Website"
    },
    {
        imgsrc: pro9,
        title: "Developer Landing Page",
        text: "Documentation Website using HTML, CSS (Responsive)",
        view: "https://developer-landing-page.web.app/",
        source: "https://github.com/iambibhu/Developer-Landing-Page"
    },
    {
        imgsrc: pro2,
        title: "Food Order Website",
        text: "Simple food order website using React JS, HTML, CSS",
        view: "https://restaurant-bib.netlify.app/",
        source: "https://github.com/iambibhu/Food-Order-Website"
    },
    {
        imgsrc: pro4,
        title: "Glassmorphic SignUp Page",
        text: "Stylish SignUp page using HTML, CSS",
        view: "https://signup-bib.netlify.app/",
        source: "https://github.com/iambibhu/Glassmorphic-SignUp-Page"
    },
    {
        imgsrc: pro7,
        title: "Parallax Website",
        text: "Parallax Website using HTML, CSS",
        view: "https://parallax-website-9b627.web.app/",
        source: "https://github.com/iambibhu/Parallax-Website"
    },
    {
        imgsrc: pro8,
        title: "Documentation Website",
        text: "Documentation Website using HTML, CSS",
        view: "https://documentationweb-982bb.web.app/",
        source: "https://github.com/iambibhu/Documentation-Website"
    },
    {
        imgsrc: pro6,
        title: "Job Application Form",
        text: "Job Application Form using HTML, CSS (Responsive)",
        view: "https://job-application-form-54e81.web.app/",
        source: "https://github.com/iambibhu/Job-Application-Form"
    },
    {
        imgsrc: pro5,
        title: "Tribute Website",
        text: "Tribute page using HTML, CSS (Responsive)",
        view: "https://tribute-website-55b16.web.app/",
        source: "https://github.com/iambibhu/Tribute-Page"
    },
];

export default ProjectcardData;